<template>
  <div class="login-form" v-show="showWx">
    <div class="form-header">
      <p>微信扫码登录</p>
      <div class="form-weixin">
        <div class="go-weixin">APP扫码登录</div>
        <img src="@/assets/img/login/QR-code.png" alt @click.prevent="showQrcodeBox" />
      </div>
    </div>
    <div class="form-body pr">
      <div id="wx-box" class="hide"></div>
      <h4 class="pa center errorCol" style="top: 100px;">微信登录维护中，请选择其他方式登录！</h4>
    </div>
    <div class="wx-footer">
      <img src="@/assets/img/icon/u4183.png" alt="" style="margin-right:10px;float:left" />
      <span style="cursor: pointer;" @click.prevent="showLoginForm">使用通行证密码登录</span>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex';
export default {
  props: {
    showWx: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    ...mapActions(['user/actionSetStatement']),
    wxLogin () {
      /* eslint-disable */
      let wxobj = new WxLogin({
        id: "wx-box",
        appid: "wxebbc91ae550cfb80",
        scope: "snsapi_login",
        redirect_uri:
          "https://www.weihudashi.com/api/wx/validateWxCode.htm",
        state:
          "https://www.weihudashi.com/v2/home/barManager/index/barAll",
        style: "black",
        href: "https://www.weihudashi.com/css/weixin.css",
      });
      this["user/actionSetStatement"](1);
    },
    showLoginForm () {
      this.$emit("showLoginForm");
    },
    showQrcodeBox () {
      this.$emit("showQrcodeBox");
    },
  },
};
</script>
<style lang="scss" scoped>
.login-form,
.register-form {
  padding: 20px 30px;
  width: 380px;
  height: 440px;
  border-radius: 3px;
  background-color: #fff;
  // backface-visibility: hidden;
}

// 表单头部
.form-header {
  display: flex;
  justify-content: space-between;

  p {
    font-size: 20px;
    font-weight: bold;
  }

  .form-weixin {
    display: flex;

    .go-weixin {
      padding-left: 8px;
      transform: translateX(5px);
      width: 96px;
      height: 28px;
      background: url(../../assets/img/login/wx.png) no-repeat;
      color: #00c2de;
      line-height: 28px;
      font-weight: bold;
      text-align: left;
    }

    img {
      cursor: pointer;
    }

    img:hover {
      opacity: 0.8;
      transition: opacity 0.2s;
    }
  }
}

.wx-footer {
  position: absolute;
  left: 120px;
  bottom: -50px;
  line-height: 20px;
  color: rgb(82, 212, 243);
}
</style>
